import { ComposeViewState } from 'owa-mail-compose-store';
import { ClientItem } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import findInlineComposeViewState from 'owa-mail-compose-actions/lib/utils/findInlineComposeViewState';
import { lazyReplyToMessageAndCreateViewState } from 'owa-mail-compose-actions';
import { SmartDocOption } from 'owa-mail-smart-pill-features';

export default async function replyToMessageAndCreateViewStateWithSmartDocOption(
    item: ClientItem,
    option: SmartDocOption
): Promise<ComposeViewState> {
    let viewState: ComposeViewState = findInlineComposeViewState(item.ConversationId.Id);

    if (!viewState) {
        // If the compose form is not opened, open the compose form.
        const replyToMessageAndCreateViewState = await lazyReplyToMessageAndCreateViewState.import();

        viewState = await replyToMessageAndCreateViewState({
            referenceItemOrId: <Message>item,
            isReplyAll: true,
            useFullCompose: false,
            instrumentationContexts: null,
            conversationId: item.ConversationId.Id,
            body: null,
            smartDocOption: option, // indicating file picker type
        });
    }

    return viewState;
}
